/* 动画方向或者形状动画类型 */
import React, { CSSProperties } from 'react';
import { AnimType, ENTR_ID_MAP, EXIT_ID_MAP } from '@tencent/slide-sdk-model';
import i18n from '@i18next/i18n';
import Menu from '@tencent/dui/lib/components/Menu';
import Divider from '@tencent/dui/lib/components/Divider';
import { ANIM_ITEM_TEXT, SHAPE_LIST } from '@src/js/js-keyframe-animation/style-converter/constants';

const AnimItemEffect = (props: {
    animType: AnimType,
    subType: string | number;
    sTypes: Array<string | number>;
    onSubTypeChange: (subType: string | number) => void;
    onShapeChange: (shapeId: number) => void
}) => {
    const { animType, subType, sTypes, onSubTypeChange, onShapeChange } = props;

    const titleStyle: CSSProperties = {
        paddingLeft: 16,
    };

    const itemStyle: CSSProperties = {
        fontSize: 12,
        display: 'inline-block',
        width: '100%',
        cursor: 'default',
    };

    return (
        <Menu
            style={{ border: 'none' }}
            itemStyle={{ width: '100%' }}>
            <Menu.Item disabled style={titleStyle}>
                {i18n.t('方向')}
            </Menu.Item>
            {
                sTypes.map(st => (
                    <Menu.Item
                        key={`menu-${st}`}
                        id={st}
                        selected={subType === `${st}`}
                        style={itemStyle}
                        onClick={() => {
                            onSubTypeChange?.(`${st}`);
                        }}
                    >
                        {ANIM_ITEM_TEXT[animType + st] || ''}
                    </Menu.Item>
                ))
            }
            <Divider />
            <Menu.Item disabled style={titleStyle}>{i18n.t('形状')}</Menu.Item>
            {

                SHAPE_LIST.map(shape => (
                    <Menu.Item
                        key={`shape-${shape.id}`}
                        style={itemStyle}
                        selected={
                            ENTR_ID_MAP[shape.id] === animType
                || EXIT_ID_MAP[shape.id] === animType
                        }
                        id={shape.id}
                        onClick={() => {
                            onShapeChange?.(shape.id);
                        }}
                    >
                        {shape.label}
                    </Menu.Item>
                ))
            }
        </Menu>
    );
};

export default AnimItemEffect;
